import React from 'react';

import Html from '~/commons/components/Html.jsx';

const KeyLearning = ({ children }) => (
  <div className="my-4">
    <h4 className="mb-3">
      <img
        className="mt-n1 mr-2"
        src="/assets/img/key-learning.svg"
        style={{ width: '28px' }}
      />
      詞句一分鐘
    </h4>
    <Html>{children}</Html>
  </div>
);

export default KeyLearning;
